import {USAGE_PLAN_STORE_NAME} from '../reducers/reducers'

export function getUsagePlanItems(state) {
    const stored = state[USAGE_PLAN_STORE_NAME] || { }
    return stored.items
}
